import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import logonew from "../imgs/logonewsmall.png";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const isActive = (path) => location.pathname === path;

  const linkClasses = (path) =>
    `relative px-3 py-2 tracking-wide transition-all duration-300 
     ${isActive(path) ? "text-gold-gradient font-bold" : "text-gray-300 hover:text-white"}`;

  return (
    <>
      {/* 🔹 Top Info Bar */}
      <div className="hidden md:flex justify-between items-center px-6 lg:px-12 py-2 bg-[#111111] text-gray-300 text-sm">
        <div className="flex items-center gap-6">
          <p className="flex items-center gap-2">
            <svg className="w-4 h-4 text-yellow-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 11c1.657 0 3-1.343 3-3S13.657 5 12 5 9 6.343 9 8s1.343 3 3 3z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 21s8-5.686 8-13a8 8 0 10-16 0c0 7.314 8 13 8 13z" />
            </svg>
            Kolkata, India
          </p>
        </div>

        <div className="flex items-center gap-6">
          <a href="mailto:info@mndconsultant.com" className="flex items-center gap-2 hover:text-yellow-400 transition">
            <svg className="w-4 h-4 text-yellow-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 4h16v16H4V4z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 4l8 8 8-8" />
            </svg>
            info@mndconsultant.com
          </a>
          <a href="tel:+918583922207" className="flex items-center gap-2 hover:text-yellow-400 transition">
            <svg className="w-4 h-4 text-yellow-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h2.28a2 2 0 011.94 1.52l.68 2.73a2 2 0 01-.45 1.82l-1.27 1.27a16.002 16.002 0 006.36 6.36l1.27-1.27a2 2 0 011.82-.45l2.73.68a2 2 0 011.52 1.94V19a2 2 0 01-2 2h-1C9.163 21 3 14.837 3 7V5z" />
            </svg>
            +91 8583922207
          </a>
        </div>
      </div>

      {/* 🔹 Desktop / Tablet Header */}
      <header className={`fixed top-[32px] left-0 w-full z-50 transition-all duration-500 ${isScrolled ? "bg-[#1C1C1C] bg-opacity-95 shadow-lg" : "bg-transparent"}`}>
        <div className="w-full flex justify-between items-center px-6 lg:px-12 py-3">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2">
            <img src={logonew} alt="Logo" className="h-[40px] lg:h-[55px] w-auto" />
            <div>
              <h1 className="font-mnd font-bold text-gold-gradient text-sm md:text-lg lg:text-xl">
                MnD Consultation Services
              </h1>
              <p className="font-mnd italic text-[11px] md:text-sm text-gold-gradient">
                From Vision to Execution
              </p>
            </div>
          </a>

          {/* Nav Links */}
          <nav className="hidden lg:flex gap-6 uppercase text-sm">
            <a href="/" className={linkClasses("/")}>Home</a>
            <a href="/about-us" className={linkClasses("/about-us")}>About Us</a>
            <a href="/interior" className={linkClasses("/interior")}>Interior & Exterior</a>
            <a href="/hiring" className={linkClasses("/hiring")}>HR & Management</a>
            <a href="/education" className={linkClasses("/education")}>Education</a>
            <a href="/contact-us" className={linkClasses("/contact-us")}>Contact</a>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <a href="tel:+918583922207" className="bg-gradient-to-r from-yellow-500 to-yellow-700 text-white px-5 py-2 rounded-full shadow-lg hover:scale-105 transition">
              Call Us
            </a>
          </div>

          {/* Tablet / Mobile Menu Icon */}
          <button onClick={toggleMenu} className="flex lg:hidden text-white focus:outline-none">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </header>

      {/* 🔹 Mobile / Tablet Menu */}
      <div className={`fixed inset-0 z-[9999] bg-[#1C1C1C] bg-opacity-95 backdrop-blur-lg overflow-y-auto transform transition-transform duration-500 ${isMenuOpen ? "translate-x-0" : "translate-x-full"} lg:hidden`}>
        <div className="flex flex-col items-center justify-start min-h-screen py-10 space-y-6 px-6">
          {/* Close Button */}
          <button onClick={() => setIsMenuOpen(false)} className="self-end mb-6 text-white focus:outline-none">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Logo */}
          <a href="/" onClick={() => setIsMenuOpen(false)}>
            <img src={logonew} alt="Logo" className="h-20 w-auto mx-auto" />
          </a>

          {/* Nav Links */}
          <div className="flex flex-col items-center space-y-4 mt-6 w-full">
            <a href="/" className="text-2xl text-gold-gradient font-bold text-center" onClick={() => setIsMenuOpen(false)}>Home</a>
            <a href="/about-us" className="text-2xl text-white hover:text-gold-gradient text-center" onClick={() => setIsMenuOpen(false)}>About Us</a>
            <a href="/interior" className="text-2xl text-white hover:text-gold-gradient text-center" onClick={() => setIsMenuOpen(false)}>Interior & Exterior</a>
            <a href="/hiring" className="text-2xl text-white hover:text-gold-gradient text-center" onClick={() => setIsMenuOpen(false)}>HR & Management</a>
            <a href="/education" className="text-2xl text-white hover:text-gold-gradient text-center" onClick={() => setIsMenuOpen(false)}>Education</a>
            <a href="/contact-us" className="text-2xl text-white hover:text-gold-gradient text-center" onClick={() => setIsMenuOpen(false)}>Contact</a>

            {/* Call Button */}
            <a href="tel:+918583922207" className="mt-4 bg-gradient-to-r from-yellow-500 to-yellow-700 text-white px-5 py-2 rounded-full shadow-lg hover:scale-105 transition text-center" onClick={() => setIsMenuOpen(false)}>Call Us</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
